























































import { Component, Vue } from 'vue-property-decorator';

import { OnMultiImport } from '../common/enum/on-multi-import';
import Loading from '../components/Loading.vue';
import VSelect from '../components/VSelect.vue';
import HttpServiceSettings from '../http/http-service-settings';
import { Settings } from '../models/settings';

interface Config {
  title: string;
  description: string;
  key: keyof Settings;
  loading: boolean;
  active: boolean;
  onToggle?: (config: Config) => void;
  component?: {
    view: any;
    props?: any;
    on?: any;
  };
}

@Component({
  components: {
    Loading,
    VSelect,
  },
})
export default class ConfigGeneral extends Vue {
  settings: Settings = null;

  configs: Config[] = [];

  isLoading = false;

  error = false;

  get company() {
    return this.$store.state.company;
  }

  async created() {
    await this.initConfigs();

    this.configs = [
      {
        title: 'Cronômetro de Importação',
        description: 'Exibe cronômetro ao realizar importação de layouts até sua finalização.',
        key: 'usesImportTimer',
        loading: false,
        active: Boolean(this.settings.usesImportTimer),
        onToggle: (config) => {
          this.onConfigChange(config, !config.active, config.active);
        },
      },
      {
        title: 'Importação multipla',
        description: 'Como a importação deve ocorrer quando houver importações na mesma empresa, layout e período.',
        key: 'onMultiImport',
        loading: false,
        active: Boolean(this.settings.onMultiImport),
        onToggle: (config) => {
          if (!config.active) {
            this.onConfigChange(config, this.settings[config.key], null);
          }
        },
        component: {
          view: VSelect,
          on: {
            select: (value: string) => {
              const config = this.configs[1];

              this.onConfigChange(config, this.settings[config.key], value);
            },
          },
          props: {
            options: Object.values(OnMultiImport),
            customLabel: (value: OnMultiImport) =>
              ({
                [OnMultiImport.override]: 'Sobrescrever Dados',
                [OnMultiImport.keepAll]: 'Incluir Dados',
              }[value]),
            allowEmpty: false,
            placeholder: 'Selecione uma opção',
            style: {
              width: '250px',
            },
          },
        },
      },
      {
        title: 'Alerta de rubricas não exportáveis',
        description:
          'Exibe um alerta quando houver rubricas não exportáveis ao realizar exportação da consulta de movimentos variáveis para o DP',
        key: 'skipNonExportableRubricsAlert',
        loading: false,
        active: !this.settings.skipNonExportableRubricsAlert,
        onToggle: (config) => {
          this.onConfigChange(config, config.active, !config.active);
        },
      },
    ];
  }

  async initConfigs() {
    this.settings = await this.getSettings();
  }

  getSettings() {
    if (this.company.settings) {
      return this.company.settings;
    }

    return this.getSettingsFromBase();
  }

  async getSettingsFromBase() {
    this.isLoading = true;

    const response = await HttpServiceSettings.read();

    this.isLoading = false;

    this.error = !response;

    return response.data || null;
  }

  toggleActive(config: Config) {
    config.active = !config.active;
    config.onToggle && config.onToggle(config);
  }

  async onConfigChange(config: Config, oldValue: any, newValue: any) {
    (this.settings[config.key] as any) = newValue;

    config.loading = true;

    const response = await HttpServiceSettings.update({
      id: this.settings.id,
      [config.key]: this.settings[config.key],
    });

    config.loading = false;

    if (response) {
      this.storeChange();
    } else {
      (this.settings[config.key] as any) = oldValue;
    }
  }

  storeChange() {
    const { company } = this;

    company.settings = this.settings;
    this.$store.commit('setCompany', company);
  }

  reload() {
    window.location.reload();
  }
}
